import { render, staticRenderFns } from "./ListPostItem.vue?vue&type=template&id=a8ef16f6&scoped=true&"
import script from "./ListPostItem.vue?vue&type=script&lang=js&"
export * from "./ListPostItem.vue?vue&type=script&lang=js&"
import style0 from "./ListPostItem.vue?vue&type=style&index=0&id=a8ef16f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ef16f6",
  null
  
)

export default component.exports